import { useCallback, useMemo, useState } from "react";
import { LottieSplatPlayer } from "./LottieSplatPlayer";

const EGG_PLAYS = 3;

const EDGES = ["left", "right", "top", "bottom"] as const;
type EggScreenEdge = (typeof EDGES)[number];

function edgeSeriesForDedupe(dedupeId: string): EggScreenEdge[] {
  let h = 2166136261;
  for (let i = 0; i < dedupeId.length; i++) {
    h = Math.imul(h ^ dedupeId.charCodeAt(i), 16777619);
  }
  const out: EggScreenEdge[] = [];
  for (let p = 0; p < EGG_PLAYS; p++) {
    h = Math.imul(h ^ (p + 1) * 0x9e3779b9, 2654435761);
    out.push(EDGES[(h >>> 0) % EDGES.length]!);
    h = (h >>> 3) ^ (p << 11);
  }
  return out;
}

type Props = {
  dedupeId: string;
  src: string;
  filter?: string;
  onComplete: () => void;
  className?: string;
};

/** Egg throw: same Lottie three times, each from a random edge (left / right / top / bottom). */
export function EggTripleThrowLottie({
  dedupeId,
  src,
  filter,
  onComplete,
  className,
}: Props) {
  const [playIndex, setPlayIndex] = useState(0);
  const edges = useMemo(() => edgeSeriesForDedupe(dedupeId), [dedupeId]);

  const onOnePlayComplete = useCallback(() => {
    if (playIndex < EGG_PLAYS - 1) {
      setPlayIndex((n) => n + 1);
    } else {
      onComplete();
    }
  }, [playIndex, onComplete]);

  const edge = edges[playIndex] ?? "left";

  return (
    <div className="reaction-splat-pop-inner reaction-scene-reveal">
      <div
        className={`reaction-egg-triple-anchor reaction-egg-triple-anchor--${edge}`}
      >
        <div className="reaction-egg-triple-lottie-wrap">
          <LottieSplatPlayer
            key={`${playIndex}-${src}`}
            src={src}
            filter={filter}
            onComplete={onOnePlayComplete}
            className={className}
          />
        </div>
      </div>
    </div>
  );
}
